var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"value":_setup.isOpen,"scrollable":""},on:{"input":_setup.onInput}},[_c('v-card',{staticClass:"pdf-viewer-card"},[_c('v-card-text',[(_vm.pdfUrl)?_c(_setup.PdfViewer,{attrs:{"pdfUrl":_vm.pdfUrl,"onClick":_setup.downloadPdf}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }